'use client';

import React from 'react';
import { config } from '@/src/config';
import styles from './Auth.module.css';

interface FacebookSignInButtonProps {
  label: string;
  referral?: string;
  disabled?: boolean;
}

const FACEBOOK_AUTH_ENDPOINT = 'https://www.facebook.com/v19.0/dialog/oauth';
const FACEBOOK_SCOPES = 'email,public_profile';

const FacebookSignInButton: React.FC<FacebookSignInButtonProps> = ({ label, referral, disabled }) => {
  if (!config.FACEBOOK_CLIENT_ID) return null;

  const handleClick = () => {
    const clientId = config.FACEBOOK_CLIENT_ID;
    const redirectUri = `${window.location.origin}/facebook`;
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: 'code',
      scope: FACEBOOK_SCOPES,
      auth_type: 'rerequest',
    });

    if (referral) {
      params.set('state', encodeURIComponent(JSON.stringify({ referral })));
    }

    window.location.href = `${FACEBOOK_AUTH_ENDPOINT}?${params.toString()}`;
  };

  return (
    <button
      type="button"
      className={styles.facebookButton}
      onClick={handleClick}
      disabled={disabled}
      aria-label={label}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="#1877F2"
          d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854V15.47H7.078V12h3.047V9.356c0-3.007 1.792-4.668 4.533-4.668 1.313 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.47h-2.796v8.384C19.612 22.954 24 17.99 24 12z"
        />
      </svg>
      <span>{label}</span>
    </button>
  );
};

export default FacebookSignInButton;
